import Usermenu from '../Usermenu/Usermenu';
import React, { useRef, useState } from 'react';
import './Header.css';
import { Link, NavLink } from 'react-router-dom';
import { defaultSPALogoData, getSkillsURL } from '../../hooks/helpers';
import logoImg from '../../assets/images/ibl-logos--copy_1.png';
import logoImg500 from '../../assets/images/ibl-logos--copy_1-p-500.png';
import logoImg800 from '../../assets/images/ibl-logos--copy_1-p-800.png';
import logoImg1080 from '../../assets/images/ibl-logos--copy_1-p-1080.png';
import logoImg1600 from '../../assets/images/ibl-logos--copy_1-p-1600.png';
import logoImg2000 from '../../assets/images/ibl-logos--copy_1-p-2000.png';
import { getPerLearnerUsers } from '../../hooks/utils/perLearner';
import { useDebounce } from '../../hooks/useDebounce';
import { IBLSpinLoader } from '@iblai/ibl-web-react-common';
import $ from 'jquery';

const skillsURL = getSkillsURL();

const Header = (props) => {
  const [search, setSearch] = useState('');
  const [searchedUsers, setSearchedUsers] = useState([]);
  const [searchedUsersLoading, setSearchedUsersLoading] = useState(false);
  const searchAutoCompleteBoxRef = useRef(null);

  const handlePerLearnersLoad = () => {
    searchAutoCompleteBoxRef.current.style.display = 'none';
    if (search === '' || search.length < 3) {
      setSearchedUsersLoading(false);
      setSearchedUsers([]);
    } else {
      setSearchedUsersLoading(true);
      getPerLearnerUsers(search, 10, (data) => {
        const updatedData = Array.isArray(data?.data) ? data.data : [];
        setSearchedUsers(updatedData);
        if (updatedData.length > 0) {
          searchAutoCompleteBoxRef.current.style.display = 'block';
        }
        setSearchedUsersLoading(false);
      });
    }
  };

  const handleAutoCompleteDropdownClose = () => {
    //HIDING DROPDOWN WHEN CLICKING ELSEWHERE
    $(document).on('click', function (e) {
      if (
        $('.header-search-bar .autocomplete-users:visible').length === 1 &&
        !$(e.target).closest('.header-search-bar .autocomplete-users').length
      ) {
        $('.header-search-bar .autocomplete-users').hide();
      }
    });
  };

  useDebounce(handlePerLearnersLoad, 300, [search]);
  useDebounce(handleAutoCompleteDropdownClose, 200, []);

  return (
    <div className="nav">
      <div className="div-block">
        <NavLink
          className="link-block-17 w-inline-block"
          to="/"
          prop-events-value-onclick="handleHeaderLogoClick"
        >
          <img
            alt=""
            className="image"
            loading="lazy"
            sizes="(max-width: 991px) 100vw, 202.1640625px"
            src={defaultSPALogoData.logo || logoImg}
            srcSet={
              defaultSPALogoData.logo
                ? ''
                : `${logoImg500} 500w, ${logoImg800} 800w, ${logoImg1080} 1080w, ${logoImg1600} 1600w, ${logoImg2000} 2000w`
            }
          />
        </NavLink>
        <div className="div-block-3">
          <div className="s-input">
            <div className="form-block-4 w-form">
              <form
                className="form header-search-bar"
                data-name="Email Form 4"
                data-wf-element-id="b549767a-be92-96be-160e-af9a114bf577"
                data-wf-page-id="657af3ad1367da03b3b1262f"
                id="email-form-4"
                method="get"
                name="email-form-4"
                prop-events-value-onsubmit="handleHeaderSearchBarSubmit"
              >
                <div className="div-block-245">
                  <input
                    className="text-field-2 w-input"
                    data-name="Name"
                    id="name"
                    maxLength={256}
                    name="name"
                    placeholder=""
                    type="text"
                    onChange={(e) => setSearch(e?.target?.value)}
                  />
                  <div
                    ref={searchAutoCompleteBoxRef}
                    className="autocomplete-users"
                  >
                    {searchedUsers.map((user, index) => (
                      <Link
                        key={index}
                        className="user-row"
                        to={`/per-learner/learners/${user?.username}`}
                        previewlistener="true"
                      >
                        {user?.full_name || '-'}
                      </Link>
                    ))}
                  </div>

                  <div
                    onClick={
                      !searchedUsersLoading
                        ? () => handlePerLearnersLoad()
                        : () => {}
                    }
                    className="div-block-246"
                  >
                    {searchedUsersLoading ? (
                      <IBLSpinLoader size={18} color={'#FFF'} />
                    ) : (
                      <div className="text-block fa_icon mg"></div>
                    )}
                  </div>
                </div>
              </form>
              <div className="w-form-done">
                <div>Thank you! Your submission has been received!</div>
              </div>
              <div className="w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
          <div className="div-block-2">
            <a
              className="ai-skills-btn w-inline-block"
              href={skillsURL}
              prop-events-value-onclick="handleAISkillsBtnClick"
            >
              <div className="text-block-130">AI Skills</div>
            </a>
          </div>
          <div className="div-block-2">
            <NavLink
              to="/invites"
              className="link-block-18 w-inline-block"
              prop-events-value-onclick="handleDownloadBtnClick"
            >
              <div className="text-block-130">Invites</div>
            </NavLink>
          </div>
          <div className="div-block-2">
            <NavLink
              to="/downloads"
              className="link-block-18 w-inline-block"
              prop-events-value-onclick="handleDownloadBtnClick"
            >
              <div className="text-block-130">Downloads</div>
            </NavLink>
          </div>
          <div className="div-block-2 hidden">
            <div className="notifications_trigger">
              <a
                className="link-block-18 w-inline-block"
                href="notifications.html"
              >
                <div className="text-block-130">Notifications</div>
              </a>
            </div>
          </div>
          <div className="div-block-2 nav-field hidden">
            <div className="roles">
              <img
                alt=""
                className="user-img nb"
                loading="lazy"
                src="images/setting_1setting.png"
              />
              <div className="text-block-130 sp">Roles</div>
              <div className="text-block fa_icon arrow"></div>
              <div className="div-block-164 profile">
                <div className="div-block-165">
                  <div className="text-block-104">Ashley Miller</div>
                  <div className="text-block-104 em">ashley@gmail.com</div>
                </div>
                <Link className="link-block-11 w-inline-block" to="#">
                  <div className="text-block-106">Overview</div>
                </Link>
                <Link className="link-block-11 w-inline-block" to="#">
                  <div className="text-block-106">Profile</div>
                </Link>
                <Link className="link-block-11 w-inline-block" to="#">
                  <div className="text-block-106">Log Out</div>
                </Link>
              </div>
              <div className="roles_popup">
                <div className="div-block-195">
                  <Link className="link-2" to="#">
                    Admin
                  </Link>
                </div>
                <div className="div-block-195">
                  <Link className="link-2" to="#">
                    Instructor
                  </Link>
                </div>
                <div className="div-block-195 last">
                  <Link className="link-2" to="#">
                    Editor
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <Usermenu></Usermenu>
        </div>
        <div className="mobile_nav_trigger">
          <div className="text-block fa_icon"></div>
        </div>
      </div>
      <div className="mobile_menu">
        <div className="div-block-3 mob">
          <div className="div-block-2 nav-searchh">
            <div className="text-block fa_icon"></div>
          </div>
          <div className="div-block-2 nav-field">
            <div className="form-block w-form">
              <form
                data-name="Email Form"
                data-wf-element-id="f19f4444-286e-d7ee-ce71-456a79932a8b"
                data-wf-page-id="657af3ad1367da03b3b1262f"
                id="email-form"
                method="get"
                name="email-form"
              >
                <div>
                  <select
                    className="select-field w-select"
                    data-name="Field 4"
                    id="field-4"
                    name="field-4"
                  >
                    <option value="">All Users</option>
                    <option value="First">First choice</option>
                    <option value="Second">Second choice</option>
                    <option value="Third">Third choice</option>
                  </select>
                </div>
              </form>
              <div className="w-form-done">
                <div>Thank you! Your submission has been received!</div>
              </div>
              <div className="w-form-fail">
                <div>Oops! Something went wrong while submitting the form.</div>
              </div>
            </div>
          </div>
          <div className="div-block-2">
            <div className="profile_menu_trigger">
              <img
                alt=""
                className="image-4"
                loading="lazy"
                src="images/cropped-5ff88d1d053bdb0e43bdcc0c_beautiful-1274361_1280-1-1.jpeg"
              />
              <div className="text-block fa_icon arrow"></div>
              <div className="div-block-164 profile">
                <div className="div-block-165">
                  <div className="text-block-104">Ashley Miller</div>
                  <div className="text-block-104 em">ashley@gmail.com</div>
                </div>
                <Link className="link-block-11 w-inline-block" to="#">
                  <div className="text-block-106">Overview</div>
                </Link>
                <Link className="link-block-11 w-inline-block" to="#">
                  <div className="text-block-106">Profile</div>
                </Link>
                <Link className="link-block-11 w-inline-block" to="#">
                  <div className="text-block-106">Log Out</div>
                </Link>
              </div>
            </div>
            <div className="prof_menu_popup">
              <div className="div-block-195">
                <Link className="link-2" to="#">
                  My Profile
                </Link>
              </div>
              <div className="div-block-195">
                <Link className="link-2" to="#">
                  Groups of Learners
                </Link>
              </div>
              <div className="div-block-195 last">
                <Link className="link-2" to="#">
                  Log Out
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
